const ENABLE_MANAGE_CREDIT_CARDS = process.env.VUE_APP_ENABLE_MANAGE_CREDIT_CARDS;
const ENABLE_RECURRING = process.env.VUE_APP_ENABLE_RECURRING;

export const listMenuNavigation = [
    {
        title: "Personal Details",
        icon: "personal.png",
        isRedirect: false,
        url: "/personal-detail",
        isShow: true
    },
    {
        title: "My Numbers",
        icon: "hashtag.png",
        isRedirect: false,
        url: "/favourite",
        isShow: true
    }, 
    {
        title: "Manage Cards",
        icon: "manage.png",
        isRedirect: true,
        url: "/manage-cards",
        isShow: ENABLE_MANAGE_CREDIT_CARDS !== 'no' ? true : false
    },
    {
        title: "My Wallet",
        icon: "dollar.png",
        isRedirect: true,
        url: "/wallet",
        isShow: true
    },
    {
        title: "Notifications",
        icon: "notifi.png",
        isRedirect: false,
        url: "/notifications",
        isShow: true
    },
    {
        title: "Recurring Games",
        icon: "recurring.png",
        isRedirect: true,
        url: "/recurring-games",
        isShow: ENABLE_RECURRING !== 'no' ? true : false
    },
    {
        title: "My Transactions",
        icon: "my-transactions.png",
        isRedirect: false,
        url: "/my-transactions",
        isShow: true
    },
];
